import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import SvgAccount from '@clearscore/rainbow.icons.account-hoverable';
import Badge from '@shared/badge';

import styles from './account-navigation.css';

const AccountNavigation = ({ firstName, handleAccountToggle, theme, noNotifications }) => {
    const containerClass = cx(styles.container, [styles[theme]]);
    const nameClass = cx(styles.accountNavigationName, [styles[theme]]);

    return (
        <button type="button" className={containerClass} onClick={handleAccountToggle} data-qa="account-open-side-menu">
            {firstName && <div className={nameClass}>Hi {firstName}</div>}
            <If condition={noNotifications}>
                <span className={styles.badge}>
                    <Badge value={noNotifications} />
                </span>
            </If>
            <SvgAccount width={32} height={32} />
        </button>
    );
};

AccountNavigation.themes = {
    DEFAULT: 'onBackground',
    WHITE: 'onWhite',
};

AccountNavigation.propTypes = {
    firstName: PropTypes.string,
    handleAccountToggle: PropTypes.func,
    theme: PropTypes.string,
    noNotifications: PropTypes.number,
};

AccountNavigation.defaultProps = {
    firstName: undefined,
    noNotifications: 0,
    handleAccountToggle: () => {},
    theme: AccountNavigation.themes.DEFAULT,
};

export default AccountNavigation;
